// extracted by mini-css-extract-plugin
export default {"key":"hailExpander_key__FsvD1","value":"hailExpander_value__PA7pC","icon":"hailExpander_icon__uQJBd","header":"hailExpander_header__CaWHV"};